import React, { useState, useEffect } from "react";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import logo from "../../../../assets/img/theme/squarecolorwithwebsite.png";
import { Button } from "reactstrap";
import GetAppIcon from "@material-ui/icons/GetApp";
import dateFormat from "dateformat";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";

const PDFGenerate = (props) => {
  const {
    component,
    cisresult,
    overallAudit,
    failedAudit,
    hostname,
    ipdns,
    platform,
    exedate,
    passedaudit,
    manualAudit,
    skippedAudit,
    fixedAudit,
  } = props;

  const [factresult, setFactresult] = useState([]);

  const pdfGenerateClick = () => {
    const finalPassedAudit = parseInt(passedaudit) + parseInt(fixedAudit);
    const date = dateFormat(exedate, "mmmm dS, yyyy h:MM TT ");
    const doc = new jsPDF();
    var col = ["Cis.No", "CIS Topic", "Level", "Status"];
    var col1 = ["Cis.No", "CIS Topic", "Level", "Status"];

    var rows = [];
    var rows1 = [];
    var rows2 = [];
    var rows3 = [];
    var rows4 = [];

    doc.addImage(logo, "PNG", 92, 8, 35, 42);
    doc.setFontSize(18);
    doc.text(`${component} Report`, 90, 63);
    doc.setFontSize(12);
    doc.text(20, 100, `HostName: ${hostname}`);
    doc.text(20, 110, `IP/DNS: ${ipdns}`);
    doc.text(20, 120, `Platform: ${platform}`);
    doc.text(20, 130, `Execution Date: ${date}`);
    doc.text(140, 100, `Overall Audit Counts: ${overallAudit}`);
    doc.text(140, 110, `Passed Audit Counts: ${finalPassedAudit}`);
    doc.text(140, 120, `Failed Audit Counts: ${failedAudit}`);
    if (manualAudit > 0) {
      doc.text(140, 130, `Manual Audit Counts: ${manualAudit}`);
    }
    if (skippedAudit > 0) {
      doc.text(140, 140, `Skipped Audit Counts: ${skippedAudit}`);
    }
    cisresult.map((row) => {
      row.result.map((value) => {
        var cis_number, cis_topic_name, level, status;
        if (value.status === "FAILED") {
          cis_number = value.cis_no;
          cis_topic_name = value.cis_topic_name;
          level = value.level;
          status = value.status;
          var temp = [cis_number, cis_topic_name, level, status];
          rows.push(temp);
        } else if (value.status === "PASSED") {
          cis_number = value.cis_no;
          cis_topic_name = value.cis_topic_name;
          level = value.level;
          status = value.status;
          var temp1 = [cis_number, cis_topic_name, level, status];
          rows1.push(temp1);
        } else if (value.status === "SKIPPED") {
          cis_number = value.cis_no;
          cis_topic_name = value.cis_topic_name;
          level = value.level;
          status = value.status;
          var temp2 = [cis_number, cis_topic_name, level, status];
          rows2.push(temp2);
        } else if (value.status === "FIXED") {
          cis_number = value.cis_no;
          cis_topic_name = value.cis_topic_name;
          level = value.level;
          status = value.status;
          var temp3 = [cis_number, cis_topic_name, level, status];
          rows3.push(temp3);
        } else {
          cis_number = value.cis_no;
          cis_topic_name = value.cis_topic_name;
          level = value.level;
          status = value.status;
          var temp4 = [cis_number, cis_topic_name, level, status];
          rows4.push(temp4);
        }
      });
    });

    if (failedAudit > 0) {
      doc.setFontSize(12);
      doc.addPage();
      doc.text(15, 10, "Failed Audits :");
      doc.autoTable(col, rows, {
        theme: "grid",
        margin: {
          top: 15,
        },
        headStyles: {
          valign: "middle",
          halign: "center",
        },
      });
    }
    if (passedaudit > 0) {
      doc.addPage();
      doc.setFontSize(12);
      doc.text(15, 10, "Passed Audits :");
      doc.autoTable(col1, rows1, {
        // theme: "grid",
        margin: {
          top: 15,
        },
        headStyles: {
          valign: "middle",
          halign: "center",
        },
      });
    }
    if (skippedAudit > 0) {
      doc.addPage();
      doc.setFontSize(12);
      doc.text(15, 10, "Skipped Audits :");
      doc.autoTable(col1, rows2, {
        // theme: "grid",
        margin: {
          top: 15,
        },
        headStyles: {
          valign: "middle",
          halign: "center",
        },
      });
    }
    if (fixedAudit > 0) {
      doc.addPage();
      doc.setFontSize(12);
      doc.text(15, 10, "Fixed Audits :");
      doc.autoTable(col1, rows3, {
        // theme: "grid",
        margin: {
          top: 15,
        },
        headStyles: {
          valign: "middle",
          halign: "center",
        },
      });
    }
    if (manualAudit > 0) {
      doc.addPage();
      doc.setFontSize(12);
      doc.text(15, 10, "Manual Audits :");
      doc.autoTable(col1, rows4, {
        // theme: "grid",
        margin: {
          top: 15,
        },
        headStyles: {
          valign: "middle",
          halign: "center",
        },
      });
    }
    doc.save(`${hostname}_${component}_Report.pdf`);
  };

  return (
    <>
      <button
        className={
          ipdns
            ? "bg-pink-500 text-white active:bg-lightBlue-600 font-bold text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            : "bg-blueGray-200 text-white active:bg-lightBlue-600 font-bold text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
        }
        type="button"
        onClick={pdfGenerateClick}
        disabled={ipdns ? false : true}
        //   onClick={toggle1}
      >
        <i className="mr-2 text-x">
          <ArrowCircleDownIcon size="small" fontSize="small" />
        </i>
        AUDIT REPORT
      </button>
    </>
  );
};

export default PDFGenerate;